<div class="ticket-container">
    <div class="left">
        <img class="barcode" src="../../../../../assets/projects/Backstage/barcode.jpg">
    </div>
    <div class="right">
        <div class="header">
            <img class="logo" src="../../../../../assets/projects/Volkstheater/nvt-logo.png">
        </div>
        <div class="content">
            <p class="content">{{date | date: "dd.MM.yyyy"}}</p>
            <h2 class="content">Eventticketsystem</h2>
            <h4 class="content">Eine Hassliebe</h4>
            <p class="content">von Léon Zimmermann</p>
        </div>
    </div>
</div>